export default __webpack_public_path__ + "static/media/Padron_7000Closed.bbadb084.jpg";